<template>
  <v-overlay absolute
      :value="isLoading"
      z-index="1000"
      class="loading-overlay"
      opacity="0.7">
      <v-flex class="text-center">
        <h2>{{loadingMessage}}</h2>
      </v-flex>
      <v-flex class="text-center">
        <v-progress-circular indeterminate size="60" />
      </v-flex>
    </v-overlay>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LoadingOverlay",
  computed: {
    ...mapGetters(["loadingMessage"]),
    isLoading(){
      return !!this.loadingMessage;
    }
  }
}
</script>